import React, { useEffect, useState } from "react";
import pb from "../../lib/pb";
import { useBrand } from "../context/BrandContext";

export default function BrandSettings() {

    const {
        brand,
        refreshBrand
    } = useBrand();

    const [saving, setSaving] = useState(false);

    const [form, setForm] = useState({

        brandName: "",
        tagline: "",
        businessType: "",
        category: "",

        ownerName: "",
        email: "",
        phone: "",
        website: "",
        address: "",

        description: "",
        mission: "",
        vision: "",

        currency: "INR",
        timezone: "Asia/Kolkata",
        language: "English",

        logo: null,

        marketplaceEnabled: true

    });

    useEffect(() => {

        if (!brand) return;

        setForm({

            ...form,

            ...brand,

            logo: null

        });

        // eslint-disable-next-line

    }, [brand]);

    function update(field, value) {

        setForm(prev => ({

            ...prev,

            [field]: value

        }));

    }

    async function save() {

        if (!brand) return;

        try {

            setSaving(true);

            let payload;

            if (form.logo instanceof File) {

                payload = new FormData();

                Object.entries(form).forEach(([k, v]) => {

                    if (

                        v !== null &&
                        v !== undefined &&
                        v !== ""

                    ) {

                        payload.append(k, v);

                    }

                });

            }

            else {

                payload = {

                    ...form

                };

                delete payload.logo;

            }

            await pb
                .collection("brands")
                .update(

                    brand.id,

                    payload

                );

            await refreshBrand();

            alert("Brand updated successfully.");

        }

        catch (err) {

            console.error(err);

            alert(

                err.message ||

                "Unable to save."

            );

        }

        finally {

            setSaving(false);

        }

    }

    async function deleteBrand() {

        const confirmDelete = window.confirm(

            "Delete this brand permanently?"

        );

        if (!confirmDelete) return;

        try {

            await pb
                .collection("brands")
                .delete(

                    brand.id

                );

            window.location.href = "/brand";

        }

        catch (err) {

            console.error(err);

            alert("Unable to delete brand.");

        }

    }

    const cardStyle = {

        background: "#fff",

        borderRadius: 14,

        padding: 25,

        marginBottom: 25,

        boxShadow: "0 5px 18px rgba(0,0,0,.05)"

    };

    const inputStyle = {

        width: "100%",

        padding: 12,

        marginTop: 8,

        marginBottom: 18,

        borderRadius: 8,

        border: "1px solid #ddd",

        fontSize: 15,

        boxSizing: "border-box"

    };

    return (

        <div
            style={{
                padding: 40,
                maxWidth: 1100,
                margin: "0 auto"
            }}
        >

            <h1>

                Brand Settings

            </h1>

            <p
                style={{
                    color: "#666",
                    marginBottom: 35
                }}
            >

                Manage your brand identity and business information.

            </p>

            {/* Brand Identity */}

            <div style={cardStyle}>

                <h2>

                    Brand Identity

                </h2>

                <input
                    style={inputStyle}
                    value={form.brandName}
                    placeholder="Brand Name"
                    onChange={e=>update(
                        "brandName",
                        e.target.value
                    )}
                />

                <input
                    style={inputStyle}
                    value={form.tagline}
                    placeholder="Tagline"
                    onChange={e=>update(
                        "tagline",
                        e.target.value
                    )}
                />

                <input
                    style={inputStyle}
                    value={form.businessType}
                    placeholder="Business Type"
                    onChange={e=>update(
                        "businessType",
                        e.target.value
                    )}
                />

                <input
                    style={inputStyle}
                    value={form.category}
                    placeholder="Category"
                    onChange={e=>update(
                        "category",
                        e.target.value
                    )}
                />

                <input
                    type="file"
                    onChange={e=>update(
                        "logo",
                        e.target.files[0]
                    )}
                />

            </div>

            {/* Contact */}

            <div style={cardStyle}>

                <h2>

                    Contact Information

                </h2>

                <input
                    style={inputStyle}
                    value={form.ownerName}
                    placeholder="Owner Name"
                    onChange={e=>update(
                        "ownerName",
                        e.target.value
                    )}
                />

                <input
                    style={inputStyle}
                    value={form.email}
                    placeholder="Email"
                    onChange={e=>update(
                        "email",
                        e.target.value
                    )}
                />

                <input
                    style={inputStyle}
                    value={form.phone}
                    placeholder="Phone"
                    onChange={e=>update(
                        "phone",
                        e.target.value
                    )}
                />

                <input
                    style={inputStyle}
                    value={form.website}
                    placeholder="Website"
                    onChange={e=>update(
                        "website",
                        e.target.value
                    )}
                />

                <textarea
                    style={{
                        ...inputStyle,
                        height:120
                    }}
                    value={form.address}
                    placeholder="Address"
                    onChange={e=>update(
                        "address",
                        e.target.value
                    )}
                />

            </div>

            {/* About */}

            <div style={cardStyle}>

                <h2>

                    Brand Story

                </h2>

                <textarea
                    style={{
                        ...inputStyle,
                        height:120
                    }}
                    value={form.description}
                    placeholder="Description"
                    onChange={e=>update(
                        "description",
                        e.target.value
                    )}
                />

                <textarea
                    style={{
                        ...inputStyle,
                        height:120
                    }}
                    value={form.mission}
                    placeholder="Mission"
                    onChange={e=>update(
                        "mission",
                        e.target.value
                    )}
                />

                <textarea
                    style={{
                        ...inputStyle,
                        height:120
                    }}
                    value={form.vision}
                    placeholder="Vision"
                    onChange={e=>update(
                        "vision",
                        e.target.value
                    )}
                />

            </div>

            {/* Regional */}

            <div style={cardStyle}>

                <h2>

                    Regional Preferences

                </h2>

                <input
                    style={inputStyle}
                    value={form.currency}
                    placeholder="Currency"
                    onChange={e=>update(
                        "currency",
                        e.target.value
                    )}
                />

                <input
                    style={inputStyle}
                    value={form.timezone}
                    placeholder="Timezone"
                    onChange={e=>update(
                        "timezone",
                        e.target.value
                    )}
                />

                <input
                    style={inputStyle}
                    value={form.language}
                    placeholder="Language"
                    onChange={e=>update(
                        "language",
                        e.target.value
                    )}
                />

            </div>

            {/* Marketplace */}

            <div style={cardStyle}>

                <h2>

                    Marketplace

                </h2>

                <label>

                    <input
                        type="checkbox"
                        checked={form.marketplaceEnabled}
                        onChange={e=>update(
                            "marketplaceEnabled",
                            e.target.checked
                        )}
                    />

                    {" "}Visible on Marketplace

                </label>

            </div>

            {/* Save */}

            <div
                style={{
                    display:"flex",
                    justifyContent:"space-between",
                    alignItems:"center",
                    marginTop:40
                }}
            >

                <button

                    onClick={deleteBrand}

                    style={{

                        background:"#ef4444",

                        color:"#fff",

                        border:"none",

                        padding:"14px 25px",

                        borderRadius:8,

                        cursor:"pointer"

                    }}

                >

                    Delete Brand

                </button>

                <button

                    onClick={save}

                    disabled={saving}

                    style={{

                        background:"#2563eb",

                        color:"#fff",

                        border:"none",

                        padding:"14px 35px",

                        borderRadius:8,

                        cursor:"pointer"

                    }}

                >

                    {

                        saving

                        ? "Saving..."

                        : "Save Changes"

                    }

                </button>

            </div>

        </div>

    );

}